(function () {
  'use strict';

  var WORKSHOP_BUTTON_SELECTOR = 'button[data-workshop-variant], a[data-workshop-variant]';
  var WORKSHOP_FORM_SELECTOR = 'form[data-workshop-variant]';
  var LABEL_SELECTOR = '[data-workshop-cart-label]';
  var STATE_LABEL_IN_CART = 'Ya en el carrito';
  var STATE_LABEL_ALREADY_OWNED = 'Ya tienes acceso';

  function readOwnedProductIds() {
    var raw = window.NutriOwnedProductIds;
    if (Array.isArray(raw)) {
      return raw.map(String);
    }
    return [];
  }

  function customerOwnsProduct(productId) {
    if (!productId) return false;
    var ids = readOwnedProductIds();
    return ids.indexOf(String(productId)) !== -1;
  }

  function applyAlreadyOwnedState(button) {
    button.classList.add('is-already-owned');
    button.setAttribute('aria-disabled', 'true');
    if (button.tagName === 'BUTTON' || button.tagName === 'INPUT') {
      button.setAttribute('disabled', 'disabled');
    }
    var label = getLabelElement(button);
    label.textContent = STATE_LABEL_ALREADY_OWNED;
  }

  function getLabelElement(button) {
    var label = button.querySelector(LABEL_SELECTOR);
    return label || button;
  }

  function applyInCartState(button) {
    if (button.dataset.workshopThen === 'checkout') {
      button.classList.remove('is-in-cart', 'is-loading');
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.removeAttribute('aria-busy');
      return;
    }
    if (button.classList.contains('is-in-cart')) {
      return;
    }
    var label = getLabelElement(button);
    if (!button.dataset.workshopOriginalLabel) {
      button.dataset.workshopOriginalLabel = label.textContent;
    }
    button.classList.add('is-in-cart');
    button.setAttribute('aria-disabled', 'true');
    if (button.tagName === 'BUTTON' || button.tagName === 'INPUT') {
      button.setAttribute('disabled', 'disabled');
    }
    if (button.tagName === 'A') {
      button.dataset.workshopHrefOriginal = button.getAttribute('href') || '';
      button.removeAttribute('href');
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '-1');
    }
    label.textContent = STATE_LABEL_IN_CART;
  }

  function clearInCartState(button) {
    if (!button.classList.contains('is-in-cart')) {
      return;
    }
    button.classList.remove('is-in-cart');
    button.removeAttribute('aria-disabled');
    if (button.tagName === 'BUTTON' || button.tagName === 'INPUT') {
      button.removeAttribute('disabled');
    }
    if (button.tagName === 'A') {
      var orig = button.dataset.workshopHrefOriginal;
      if (orig) button.setAttribute('href', orig);
      delete button.dataset.workshopHrefOriginal;
      button.removeAttribute('role');
      button.removeAttribute('tabindex');
    }
    var label = getLabelElement(button);
    if (button.dataset.workshopOriginalLabel) {
      label.textContent = button.dataset.workshopOriginalLabel;
    }
  }

  function applyLoadingState(button) {
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    if (button.tagName === 'BUTTON' || button.tagName === 'INPUT') {
      button.setAttribute('disabled', 'disabled');
    }
  }

  function clearLoadingState(button, restoreText) {
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    if (button.classList.contains('is-in-cart')) {
      return;
    }
    if (button.tagName === 'BUTTON' || button.tagName === 'INPUT') {
      button.removeAttribute('disabled');
    }
    if (typeof restoreText === 'string' && restoreText.length > 0) {
      var label = getLabelElement(button);
      label.textContent = restoreText;
    }
  }

  function markVariantAsInCart(variantId) {
    var selector = '[data-workshop-variant="' + variantId + '"]';
    document.querySelectorAll(selector).forEach(function (element) {
      if (element.tagName === 'FORM') {
        return;
      }
      applyInCartState(element);
    });
    document.dispatchEvent(new CustomEvent('workshop-cart:variant-locked', {
      detail: { variantId: String(variantId) }
    }));
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Respuesta /cart.js no OK: ' + response.status);
      }
      return response.json();
    });
  }

  function syncButtonsFromCart() {
    return fetchCart().then(function (cart) {
      var items = cart && cart.items ? cart.items : [];
      var variantsInCart = items.map(function (item) {
        return String(item.variant_id);
      });
      console.log('[WorkshopCart] Carrito actual contiene variantes:', variantsInCart);
      document.querySelectorAll(WORKSHOP_BUTTON_SELECTOR).forEach(function (button) {
        var variantId = String(button.dataset.workshopVariant || '');
        if (!variantId) return;
        if (variantsInCart.indexOf(variantId) !== -1) {
          applyInCartState(button);
        } else {
          clearInCartState(button);
        }
      });
    }).catch(function (error) {
      console.warn('[WorkshopCart] Falló sincronización inicial con /cart.js:', error);
    });
  }

  // G.2: marca este productId como "compra en curso" para que el player muestre la
  // pantalla failsafe solo si el customer realmente pasó por checkout para ESTE producto.
  // TTL 30 min — la lectura está en sections/taller-playlist-player.liquid (shouldShowAccessPending).
  function markPendingPurchase(productId) {
    if (!productId) return;
    try {
      window.sessionStorage.setItem(
        'nutri_pending_purchase_' + productId,
        JSON.stringify({ ts: Date.now() })
      );
    } catch (e) {}
  }

  function variantQtyInCartLive(variantId) {
    return fetchCart().then(function (cart) {
      var items = (cart && cart.items) ? cart.items : [];
      var total = 0;
      items.forEach(function (item) {
        if (String(item.variant_id) === String(variantId)) {
          total += item.quantity;
        }
      });
      return total;
    }).catch(function () {
      return 0;
    });
  }

  function addVariantToCart(variantId, originatingButton, options) {
    var redirectToCheckout = !!(options && options.redirectToCheckout);
    var productId = (options && options.productId) || originatingButton.dataset.workshopProduct || '';
    var label = getLabelElement(originatingButton);
    var originalText = label.textContent;
    applyLoadingState(originatingButton);

    // Pre-check EN VIVO: un taller solo puede estar 1 vez en el carrito.
    // La clase CSS .is-in-cart no sobrevive navegación entre páginas, por eso
    // consultamos /cart.js directo antes de cada add.
    return variantQtyInCartLive(variantId).then(function (qtyInCart) {
      if (qtyInCart > 0) {
        console.log('[WorkshopCart] Variante ya en carrito (qty ' + qtyInCart + ') → skip add.', variantId);
        markVariantAsInCart(variantId);
        clearLoadingState(originatingButton, null);
        if (redirectToCheckout) {
          markPendingPurchase(productId);
          window.location.href = '/checkout';
          return null;
        }
        var drawerExisting = document.querySelector('cart-drawer');
        if (drawerExisting && typeof drawerExisting.open === 'function') {
          try { drawerExisting.open(); } catch (e) {}
        }
        return null;
      }
      return doAddVariant(variantId, originatingButton, originalText, redirectToCheckout, productId);
    });
  }

  function doAddVariant(variantId, originatingButton, originalText, redirectToCheckout, productId) {
    // cart-notification (cart_type=notification) o cart-drawer (cart_type=drawer).
    // Pedimos las sections que el componente necesita para que /cart/add.js
    // las devuelva pre-renderizadas y podamos hacer renderContents(payload)
    // → toast visible + badge del header actualizado al instante.
    var cartNotification = document.querySelector('cart-notification');
    var cartDrawer = document.querySelector('cart-drawer');
    var cart = cartNotification || cartDrawer;
    var sectionsToRequest = [];
    if (cart && typeof cart.getSectionsToRender === 'function') {
      sectionsToRequest = cart.getSectionsToRender().map(function (s) { return s.id; });
    }

    // /cart/add.js con sections requiere multipart/form-data — el JSON body
    // suele venir sin payload.sections (quirk no documentado de Shopify).
    // _workshop_lock: marca el line item como taller para que
    // workshop-cart-enforcement.js lo detecte vía /cart.js y revierta qty>1.
    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    formData.append('properties[_workshop_lock]', 'true');
    if (sectionsToRequest.length > 0) {
      formData.append('sections', sectionsToRequest.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (errorBody) {
          throw new Error(errorBody && errorBody.description ? errorBody.description : 'cart/add.js falló: ' + response.status);
        });
      }
      return response.json();
    }).then(function (payload) {
      console.log('[WorkshopCart] Variante añadida exitosamente:', variantId, payload);
      markVariantAsInCart(variantId);
      markPendingPurchase(productId);
      clearLoadingState(originatingButton, null);
      if (redirectToCheckout) {
        window.location.href = '/checkout';
        return;
      }
      // Render toast + badge usando el mismo patrón que product-form.js de Dawn.
      // payload.sections viene del request si pedimos sections arriba.
      if (cart && typeof cart.renderContents === 'function' && payload && payload.sections) {
        if (cartNotification && typeof cartNotification.setActiveElement === 'function') {
          cartNotification.setActiveElement(originatingButton);
        }
        try {
          cart.renderContents(payload);
        } catch (renderError) {
          console.warn('[WorkshopCart] Falló render del cart-notification:', renderError);
        }
      } else if (cartDrawer && typeof cartDrawer.open === 'function') {
        try {
          cartDrawer.open();
        } catch (drawerError) {
          console.warn('[WorkshopCart] Falló apertura del drawer:', drawerError);
        }
      }
      document.dispatchEvent(new CustomEvent('workshop-cart:added', {
        detail: { variantId: String(variantId), payload: payload }
      }));
    }).catch(function (error) {
      console.warn('[WorkshopCart] Falló add:', error);
      clearLoadingState(originatingButton, originalText);
      window.alert('No se pudo agregar el taller al carrito. ' + (error && error.message ? error.message : 'Intentá de nuevo.'));
    });
  }

  function variantIsInCart(variantId) {
    var selector = 'button[data-workshop-variant="' + variantId + '"].is-in-cart, a[data-workshop-variant="' + variantId + '"].is-in-cart';
    return document.querySelector(selector) !== null;
  }

  function handleButtonClick(event) {
    var button = event.currentTarget;
    var variantId = button.dataset.workshopVariant;
    if (!variantId) {
      return;
    }
    var productId = button.dataset.workshopProduct;
    if (productId && customerOwnsProduct(productId)) {
      event.preventDefault();
      event.stopPropagation();
      applyAlreadyOwnedState(button);
      var courseUrl = button.dataset.workshopUrl || button.getAttribute('href');
      var msg = 'Ya tienes acceso a este taller.' + (courseUrl ? ' Vamos al reproductor.' : '');
      window.alert(msg);
      if (courseUrl) {
        window.location.href = courseUrl;
      }
      return;
    }
    var redirectToCheckout = button.dataset.workshopThen === 'checkout';

    if (redirectToCheckout) {
      event.preventDefault();
      event.stopPropagation();
      if (variantIsInCart(variantId)) {
        console.log('[WorkshopCart] "Comprar Ahora" con variante ya en carrito → skip AJAX, redirect directo a /checkout');
        window.location.href = '/checkout';
        return;
      }
      addVariantToCart(variantId, button, { redirectToCheckout: true });
      return;
    }

    if (button.classList.contains('is-in-cart')) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    addVariantToCart(variantId, button, { redirectToCheckout: false });
  }

  function handleFormSubmit(event) {
    var form = event.currentTarget;
    var variantId = form.dataset.workshopVariant;
    if (!variantId) {
      return;
    }
    var submitter = event.submitter;
    var triggerButton = submitter && submitter.matches('button[data-workshop-variant], input[type="submit"][data-workshop-variant]')
      ? submitter
      : form.querySelector('button[data-workshop-variant]') || form.querySelector('button[type="submit"]');
    if (!triggerButton) {
      return;
    }
    var productId = form.dataset.workshopProduct || triggerButton.dataset.workshopProduct;
    if (productId && customerOwnsProduct(productId)) {
      event.preventDefault();
      applyAlreadyOwnedState(triggerButton);
      var courseUrl = form.dataset.workshopUrl || triggerButton.dataset.workshopUrl;
      window.alert('Ya tienes acceso a este taller.' + (courseUrl ? ' Vamos al reproductor.' : ''));
      if (courseUrl) {
        window.location.href = courseUrl;
      }
      return;
    }
    var redirectToCheckout = triggerButton.dataset.workshopThen === 'checkout';

    if (redirectToCheckout) {
      event.preventDefault();
      if (variantIsInCart(variantId)) {
        console.log('[WorkshopCart] Form submit con "Comprar Ahora" + variante ya en carrito → skip AJAX, redirect directo a /checkout');
        window.location.href = '/checkout';
        return;
      }
      addVariantToCart(variantId, triggerButton, { redirectToCheckout: true });
      return;
    }

    if (triggerButton.classList.contains('is-in-cart')) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    addVariantToCart(variantId, triggerButton, { redirectToCheckout: false });
  }

  function attachListeners() {
    document.querySelectorAll(WORKSHOP_BUTTON_SELECTOR).forEach(function (button) {
      if (button.dataset.workshopWired === 'true') {
        return;
      }
      button.dataset.workshopWired = 'true';
      button.addEventListener('click', handleButtonClick);
      var productId = button.dataset.workshopProduct;
      if (productId && customerOwnsProduct(productId)) {
        applyAlreadyOwnedState(button);
      }
    });
    document.querySelectorAll(WORKSHOP_FORM_SELECTOR).forEach(function (form) {
      if (form.dataset.workshopWired === 'true') {
        return;
      }
      form.dataset.workshopWired = 'true';
      form.addEventListener('submit', handleFormSubmit);
    });
  }

  function init() {
    console.log('[WorkshopCart] init');
    attachListeners();
    syncButtonsFromCart();

    var observer = new MutationObserver(function () {
      attachListeners();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('cart:refresh', function () {
      syncButtonsFromCart();
    });

    // bfcache restore: cuando el user vuelve con "Atrás" desde /cart después de
    // eliminar el taller, el navegador restaura la página desde memoria sin
    // disparar DOMContentLoaded. pageshow con persisted=true es el único evento
    // confiable para detectarlo y re-sincronizar el estado del botón.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        syncButtonsFromCart();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
